<template>
  <div>
    <PagePartsCartPartsCarouselPcSlider
      v-if="minScreenLg"
      :slide-images="slideImages"
      :gift-wrapped="giftWrapped"
      :is-gift-wrapping-available-image="isGiftWrappingAvailableImage"
      @expand-clicked="$emit('expandClicked', $event)"
    />
    <PagePartsCartPartsCarouselSpSlider
      v-else
      :slide-images="slideImages"
      :gift-wrapped="giftWrapped"
      :is-gift-wrapping-available-image="isGiftWrappingAvailableImage"
      @expand-clicked="$emit('expandClicked', $event)"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  slideImages: string[]
  /**
   * ギフトラッピング済みか（"適用中のラッピングイメージ"の表示制御を行う）
   */
  giftWrapped: boolean
  /**
   * ギフトラッピングの画像か（"ラッピングイメージ"の出しわけを行う）
   */
  isGiftWrappingAvailableImage: (path: string) => boolean
}>()

defineEmits<{
  (e: "expandClicked", url: string): void
}>()

const { width: windowWidth } = useWindowSize()
// @mixin lg と同じ値に設定
const minScreenLg = computed(() => windowWidth.value >= 1024)
</script>
